import React from "react";
import { Typography, CardMedia, Button, Box, useTheme } from "@mui/material";

import { FONT_SECONDARY } from "@/theme/typography";
import { types } from "@/utils/staticData/aboutUsData";
import useResponsive from "@/hooks/useResponsive";

import Arrow_square_icon from "@/assets/icons/about-us/arrow-up-on-square.svg?react";
import Square_stack_icon from "@/assets/icons/about-us/square-stack.svg?react";
import { buttonStyles, iconStyles, imageStyles } from "./styles";

interface IProps {
  title: string;
  subtitle: string;
  iconUrl: string;
  type: string;
}

const BecomeDealerCard: React.FC<IProps> = ({
  title,
  subtitle,
  iconUrl,
  type,
}) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <Box
      p={{ xs: 1, md: 2 }}
      bgcolor="white"
      borderRadius={{ xs: 1.5, md: 3 }}
      minHeight={{ xs: "85%", md: "95%" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      boxShadow={theme.customShadows.resources}
    >
      <Box>
        <CardMedia
          component="img"
          image={iconUrl}
          alt={title}
          sx={imageStyles}
        />

        <Typography
          variant="caption"
          component="p"
          fontWeight={700}
          fontSize={{ xs: 7, md: 14 }}
          mb={{ xs: 1, md: 2 }}
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          component="p"
          fontFamily={FONT_SECONDARY}
          fontWeight={500}
          fontSize={{ xs: 6, md: 12 }}
          mb={{ xs: 1.5, md: 3 }}
          color={{ xs: "black", md: "text.secondary" }}
        >
          {subtitle}
        </Typography>
      </Box>

      <Box>
        {type === types.request && (
          <Button
            fullWidth
            size={isMobile ? "small" : "large"}
            variant="contained"
            disabled
            sx={buttonStyles}
          >
            Apply now
          </Button>
        )}
        {type === types.recommend && (
          <Box display="flex" gap={1}>
            <Box sx={iconStyles}>
              <Square_stack_icon />
            </Box>
            <Box sx={iconStyles}>
              <Arrow_square_icon />
            </Box>
          </Box>
        )}
        {type === types.earn && (
          <Box
            borderRadius={{ xs: 1, md: 2 }}
            bgcolor="#F9FAFC"
            py={{ xs: 0.5, md: 1.25 }}
            px={{ xs: 0.75, md: 1.5 }}
          >
            <Typography
              variant="caption"
              component="p"
              fontWeight={700}
              fontSize={{ xs: 6, md: 10, lg: 12 }}
            >
              Total
            </Typography>
            <Typography
              variant="caption"
              component="p"
              fontWeight={700}
              fontSize={{ xs: 9, md: 12, lg: 18 }}
            >
              $20,000
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default BecomeDealerCard;
